module.exports = __webpack_public_path__ + "img/cnt.04302218.png";